<i class="material-icons" [ngClass]="status">{{ getIconName() }}</i>
